/**
 * The product's name, in one place for the app and the API. Always written in lower case. Change it here
 * and every screen, message and page title follows (the logo is the Wordmark in web/src/app/Brand.tsx). Names stored in customers' sites (lists,
 * folders, columns) never use it.
 */
export const PRODUCT_NAME: string = 'docquet';
